// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"pG","text":"pH","subText":"pI","toggleContainer":"pJ","checked":"pK"};